import { apiClient } from '@/api/client'
import type { DashboardFunnelStage, DashboardRecentHire } from '@/features/admin/api/dashboard.api'
import type { ApiSuccessResponse } from '@/types/api'

export interface RecruiterTeamActivityRow {
  userId: number
  name: string
  userType: string
  isActive: boolean
  jobsPosted: number
  applicationsProcessed: number
  hires: number
  lastActionAt: string | null
}

export interface RecruiterDashboard {
  totalJobs: number
  totalApplications: number
  totalCandidatesCount: number
  hiredCount: number
  hiringFunnel: DashboardFunnelStage[]
  recentHires: DashboardRecentHire[]
  /** The signed-in recruiter's own starred candidates. */
  starredCount: number
  openPositions: { openings: number; filled: number; remaining: number }
  timeToHire: {
    averageDays: number | null
    hires: number
    byJob: { jobId: number; title: string; hires: number; averageDays: number }[]
  }
  /** Null for recruiter users — only the organization's admin sees it. */
  teamActivity: RecruiterTeamActivityRow[] | null
  countsByStatus: Record<string, number>
  recentJobs: Array<{
    id: number
    title: string
    status: string
    applicantCount: number
    createdAt: string
  }>
}

export const recruiterDashboardApi = {
  get: async () => {
    const { data } =
      await apiClient.get<ApiSuccessResponse<RecruiterDashboard>>('/recruiter/dashboard')
    return data.data
  },
}
